function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7804 24.1934C10.9543 21.9911 12.8805 20.3467 15.0828 20.5206L78.8843 25.5568C81.0866 25.7307 82.731 27.6569 82.5572 29.8592L81.2194 46.8065C81.0456 49.0087 79.1194 50.6531 76.9171 50.4793L13.1155 45.4431C10.9132 45.2692 9.26886 43.343 9.4427 41.1407L10.7804 24.1934Z",
  fill: "#FF2F3A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0931 39.6594L23.6854 40.2587L23.8353 38.3607L18.4969 37.9393L18.7898 34.2278L23.5859 34.6064L23.7304 32.7761L18.9343 32.3975L19.2005 29.025L24.5389 29.4464L24.6888 27.5483L17.0964 26.949L16.0931 39.6594Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1171 40.5296L28.7441 40.6581L32.5839 36.084L35.7094 41.2079L37.4889 41.3483L37.5905 40.0603L34.1555 34.5369L38.1925 29.842L38.2888 28.6218L36.6619 28.4934L33.0624 32.8306L30.0863 27.9743L28.2899 27.8325L28.1882 29.1205L31.4752 34.3594L27.2134 39.3094L27.1171 40.5296Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7239 42.2819C50.1303 42.5508 51.5721 40.7036 51.7255 40.2723L51.8218 39.0521L50.0932 38.9156C50.0263 39.115 49.1785 40.5658 46.9076 40.3865C44.3994 40.1885 43.0503 38.0528 43.2616 35.3751C43.477 32.6466 45.1534 30.8519 47.6447 31.0486C49.9665 31.2318 50.4629 32.7205 50.4807 32.9266L52.2093 33.063L52.3056 31.8428C52.249 31.4802 51.3013 29.4443 47.7593 29.1647C43.98 28.8664 41.289 31.4166 40.9907 35.1958C40.6964 38.9242 42.6904 41.9636 46.7239 42.2819Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.638 42.781L63.2304 43.3803L63.3802 41.4822L58.0418 41.0608L58.3348 37.3493L63.1309 37.7279L63.2754 35.8976L58.4793 35.519L58.7455 32.1465L64.0839 32.5679L64.2337 30.6698L56.6413 30.0705L55.638 42.781Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M67.6281 43.7274L75.1866 44.324L75.3364 42.4259L70.0319 42.0072L70.8854 31.1949L68.6314 31.0169L67.6281 43.7274Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.3128 68.0879L53.4385 58.9071C52.3667 58.6403 51.2814 59.2928 51.0146 60.3647L46.9074 76.8611C46.6405 77.9329 47.2931 79.0181 48.3649 79.285L85.2392 88.4658C86.311 88.7327 87.3963 88.0801 87.6632 87.0082L91.7703 70.5119C92.0372 69.44 91.3846 68.3548 90.3128 68.0879ZM53.9217 56.9664C51.778 56.4326 49.6075 57.7378 49.0738 59.8815L44.9666 76.3779C44.4329 78.5216 45.738 80.692 47.8817 81.2258L84.756 90.4066C86.8997 90.9403 89.0702 89.6351 89.6039 87.4914L93.7111 70.9951C94.2448 68.8514 92.9397 66.6809 90.796 66.1472L53.9217 56.9664Z",
  fill: "#FF2F3A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M54.1724 76.6088L56.0953 73.8816L61.1762 75.1466L61.5958 78.4571L63.3609 78.8965L63.6895 77.5768L62.0038 65.4194L60.0242 64.9265L52.7773 75.0351L52.4898 76.1899L54.1724 76.6088ZM60.964 73.1842L57.2028 72.2478L60.3032 67.8166L60.964 73.1842Z",
  fill: "#FF2F3A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M67.057 79.8168L69.251 80.363L70.3271 76.041L71.7293 76.3901C74.7316 77.1376 76.7504 75.5029 77.2843 73.3584C77.8716 70.9994 76.505 69.0298 73.7336 68.3398L70.1374 67.4445L67.057 79.8168ZM70.7665 74.2058L71.8631 69.8012L73.2653 70.1503C74.75 70.52 75.349 71.7027 75.0615 72.8575C74.7206 74.2267 73.6039 74.9122 72.1687 74.5549L70.7665 74.2058Z",
  fill: "#FF2F3A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M79.1308 82.8228L81.3248 83.3691L84.4052 70.9968L82.2112 70.4505L79.1308 82.8228Z",
  fill: "#FF2F3A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M56.1138 3.82674C56.757 1.71329 58.9916 0.521362 61.1051 1.16449L104.156 14.2651C106.269 14.9082 107.461 17.1428 106.818 19.2563L101.869 35.5199C101.226 37.6334 98.9913 38.8253 96.8778 38.1822L53.827 25.0816C51.7135 24.4385 50.5216 22.2038 51.1647 20.0904L56.1138 3.82674Z",
  fill: "#FFB800"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1341 22.4641C68.4031 23.4589 70.2082 21.9647 70.4508 21.5765L70.8071 20.4055L69.1482 19.9007C69.04 20.081 67.9002 21.3156 65.7209 20.6525C63.3139 19.92 62.4553 17.5441 63.2373 14.9745C64.0341 12.356 66.0571 10.9637 68.4478 11.6912C70.676 12.3692 70.8408 13.9298 70.8139 14.1348L72.4728 14.6397L72.8291 13.4687C72.8518 13.1024 72.3638 10.9104 68.9647 9.87602C65.3379 8.77237 62.1616 10.6845 61.058 14.3113C59.9692 17.8893 61.2633 21.2862 65.1341 22.4641Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M77.235 26.1464C79.7396 26.9086 81.928 26.0819 82.5912 23.9026C83.1851 21.9509 82.3867 20.4286 80.4457 19.216L79.385 18.5556C78.2253 17.8117 77.8045 17.1506 78.0569 16.3212C78.3291 15.4267 79.1925 14.9253 80.4936 15.3212C81.8272 15.727 82.2685 16.5543 82.2501 17.4905L83.909 17.9953L84.2654 16.8244C84.266 15.4208 83.1961 14.2067 81.1306 13.5782C78.6585 12.8259 76.5825 13.6335 75.9193 15.8128C75.3601 17.6506 76.1196 19.1256 78.1469 20.3467L79.0485 20.8876C80.3008 21.6774 80.7654 22.3696 80.4783 23.3129C80.1517 24.3863 79.0592 24.7647 77.8069 24.3836C76.4408 23.9679 75.7817 23.0388 75.7223 22.0078L74.0797 21.5079L73.7233 22.6789C73.8662 24.0196 74.9906 25.4635 77.235 26.1464Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M88.6486 29.4064L90.7954 30.0597L98.5195 20.3268L98.8659 19.1883L97.1095 18.6538L90.6072 26.9994L89.8884 16.4564L88.0343 15.8922L87.6384 17.1933L88.6486 29.4064Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 2.37939,
  y: 52.3713,
  width: 47,
  height: 21,
  transform: "rotate(-12.2744 2.37939 52.3713)",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0157 67.0198L17.2251 66.5392L14.9193 55.9411L18.7399 55.1099L18.3351 53.2494L8.48455 55.3925L8.88933 57.253L12.71 56.4218L15.0157 67.0198Z",
  fill: "#FFB800"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8448 65.0989L25.4395 64.752L27.7946 59.2638L32.2668 63.2666L34.011 62.8871L33.7363 61.6246L28.8524 57.3287L31.3613 51.6679L31.1011 50.4719L29.5064 50.8189L27.313 56.0109L23.0612 52.2211L21.3003 52.6042L21.575 53.8667L26.235 57.933L23.5846 63.9029L23.8448 65.0989Z",
  fill: "#FFB800"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8225 60.97L40.6132 61.4507L38.3074 50.8526L34.4868 51.6838L34.082 49.8234L43.9326 47.6802L44.3373 49.5407L40.5167 50.3719L42.8225 60.97Z",
  fill: "#FFB800"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.850377 54.7508C0.380727 52.5922 1.74992 50.4616 3.90856 49.9919L45.9256 40.8504C48.0842 40.3807 50.2149 41.7499 50.6845 43.9086L54.2986 60.5199C54.7683 62.6786 53.3991 64.8092 51.2405 65.2789L9.22342 74.4204C7.06478 74.8901 4.93413 73.5209 4.46448 71.3622L0.850377 54.7508ZM4.33375 51.9462L46.3508 42.8046C47.4301 42.5698 48.4954 43.2544 48.7303 44.3337L52.3444 60.9451C52.5792 62.0245 51.8946 63.0898 50.8153 63.3246L8.79823 72.4661C7.71891 72.701 6.65358 72.0164 6.41876 70.937L2.80466 54.3257C2.56983 53.2463 3.25443 52.181 4.33375 51.9462Z",
  fill: "#FFB800"
});

var SvgFileFormats = function SvgFileFormats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 91,
    viewBox: "0 0 108 91",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileFormats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fileFormats.732cebad.svg";
export { ForwardRef as ReactComponent };